<template>
    <b-list-group-item class="lista-menu" @click.stop="abrirModal()"
        ><span>Informações TCU - SGF</span>
        <filtro ref="filtroModal"></filtro>
    </b-list-group-item>
</template>
<script>
import filtro from './RelacaoContratacaoFiltro.vue'
export default {
    components: {
        filtro
    },

    methods: {
        abrirModal() {
            this.$refs.filtroModal.abrir()
        }
    }
}
</script>
